import { memo } from 'react';

import { DetailsAgentRunsPanel } from './DetailsAgentRunsPanel.tsx';
import { useOpenPanel } from './useOpenPanel.ts';

export type DetailsAgentRunsPanelWrapperProps = {
  agentId?: string;
};

const IDetailsAgentRunsPanelWrapper = ({ agentId }: DetailsAgentRunsPanelWrapperProps) => {
  const { agentRunsPanelOpen } = useOpenPanel();

  if (!agentRunsPanelOpen) return null;

  return <DetailsAgentRunsPanel agentId={agentId} />;
};

export const DetailsAgentRunsPanelWrapper = memo(IDetailsAgentRunsPanelWrapper) as typeof IDetailsAgentRunsPanelWrapper;
